<script setup lang="ts">
/* ===========================================================================
   ui-delta — RailLayout
   ---------------------------------------------------------------------------
   ADDS:      The rail-plus-content relationship, including the responsive flip.
   UPSTREAM:  No equivalent in @ui.
   AT MERGE:  Move into @ui alongside SideNav; they are only useful together.
   ORIGIN:    elfie-design guide, components/layouts/RailLayout.jsx.
   ---------------------------------------------------------------------------
   Owns the relationship so call sites cannot get it wrong: SideNav becomes a
   full-width horizontal scroller below desktop, so composing it by hand inside
   a flex row crushes the content column to zero at tablet width. Three separate
   call sites made that mistake independently, which is why it is a component.
   It fills the height it is given, so a rail's foot (SideNav) reaches the
   bottom of the panel on a short page.
   =========================================================================== */
</script>

<template>
  <div class="rail-layout">
    <slot name="rail" />
    <div class="rail-layout__content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.rail-layout {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  gap: var(--spacing-2xl);
  align-items: stretch;
  width: 100%;
  min-width: 0;
}

.rail-layout__content {
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2xl);
}

@media (min-width: 1024px) {
  .rail-layout {
    flex-direction: row;
    gap: var(--spacing-4xl);
    align-items: flex-start;
  }

  .rail-layout__content {
    flex: 1 1 0%;
    width: auto;
  }
}
</style>
